var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',_vm._l((_vm.spinningText),function(block,i){return _c('article',{key:i},[(block.header)?_c('h3',[_vm._v(_vm._s(block.header))]):_vm._e(),_vm._l((block.body),function(text,j){return _c('p',{key:j},[_vm._v(_vm._s(text))])})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }